import { createReducer, on } from '@ngrx/store';
import { AnalyticsSyncActions } from './analytics-sync.action-types';
import { AnalyticsSyncLogEntry, AnalyticsSyncResponse, AnalyticsSyncStats } from '../../../services/analytics-sync.service';

export interface AnalyticsSyncState {
  syncLogs: AnalyticsSyncLogEntry[];
  syncStats: AnalyticsSyncStats | null;
  lastSyncResponse: AnalyticsSyncResponse | null;
  isInitialLoading: boolean;
  isLoading: boolean;
  isTriggering: boolean;
  error: string | null;
}

export const initialState: AnalyticsSyncState = {
  syncLogs: [],
  syncStats: null,
  lastSyncResponse: null,
  isInitialLoading: true,
  isLoading: false,
  isTriggering: false,
  error: null,
};

export const analyticsSyncReducer = createReducer(
  initialState,

  // Reset state
  on(AnalyticsSyncActions.resetToInitialState, () => initialState),

  // Loading states
  on(AnalyticsSyncActions.setAnalyticsSyncLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),

  on(AnalyticsSyncActions.setSyncTriggering, (state, { isTriggering }) => ({
    ...state,
    isTriggering,
  })),

  // Trigger sync
  on(AnalyticsSyncActions.startTriggerSync, (state) => ({
    ...state,
    isTriggering: true,
    error: null,
  })),

  on(AnalyticsSyncActions.triggerSyncSuccess, (state, { syncResponse }) => ({
    ...state,
    lastSyncResponse: syncResponse,
    isTriggering: false,
    error: null,
  })),

  on(AnalyticsSyncActions.triggerSyncFail, (state) => ({
    ...state,
    isTriggering: false,
    error: 'Failed to trigger analytics sync',
  })),

  // Get sync logs
  on(AnalyticsSyncActions.startGetSyncLogs, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(AnalyticsSyncActions.getSyncLogsSuccess, (state, { syncLogs }) => ({
    ...state,
    syncLogs,
    isInitialLoading: false,
    isLoading: false,
    error: null,
  })),

  on(AnalyticsSyncActions.getSyncLogsFail, (state) => ({
    ...state,
    isInitialLoading: false,
    isLoading: false,
    error: 'Failed to load sync logs',
  })),

  // Get sync stats
  on(AnalyticsSyncActions.startGetSyncStats, (state) => ({
    ...state,
    error: null,
  })),

  on(AnalyticsSyncActions.getSyncStatsSuccess, (state, { syncStats }) => ({
    ...state,
    syncStats,
    error: null,
  })),

  on(AnalyticsSyncActions.getSyncStatsFail, (state) => ({
    ...state,
    error: 'Failed to load sync stats',
  })),
);
